module.exports = __webpack_public_path__ + "5bfbdf6c6099fd012940e302008d1db4.png";